import { buildRoutePath } from '@/router'

/** Leave the world for the home screen (same mechanism as the router's navigate). */
export function navigateHome(): void {
  history.pushState(null, '', buildRoutePath({ page: 'home' }))
  window.dispatchEvent(new Event('huebo:navigate'))
}
